export default "__VITE_ASSET__CHbOfDJl__"